import { Header, Title } from '../EnrollmentModal.styles';
import CloseModalButton from './CloseModalButton';

interface ModalHeaderProps {
  title: string;
  closeLabel: string;
  onClose: () => void;
}

const ModalHeader = ({ title, closeLabel, onClose }: ModalHeaderProps) => (
  <Header>
    <Title>{title}</Title>
    <CloseModalButton label={closeLabel} onClick={onClose} />
  </Header>
);

export default ModalHeader;
